import api from '../token';

export const AddInventario = async (dados) => {
  try {
    const response = await api.post('/addInventario', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
